import React from "react";

function PushIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5672 9.55782L11.0672 2.05782C10.9798 1.97031 10.8684 1.9107 10.7471 1.88655C10.6258 1.86239 10.5 1.87477 10.3858 1.92211C10.2715 1.96946 10.1738 2.04964 10.1052 2.15252C10.0365 2.25539 9.9999 2.37632 10 2.5V5.625H5.625C5.45924 5.625 5.30027 5.69085 5.18306 5.80806C5.06585 5.92527 5 6.08424 5 6.25V13.75C5 13.9158 5.06585 14.0747 5.18306 14.1919C5.30027 14.3092 5.45924 14.375 5.625 14.375H10V17.5C9.9999 17.6237 10.0365 17.7446 10.1052 17.8475C10.1738 17.9504 10.2715 18.0305 10.3858 18.0779C10.5 18.1252 10.6258 18.1376 10.7471 18.1135C10.8684 18.0893 10.9798 18.0297 11.0672 17.9422L18.5672 10.4422C18.6253 10.3841 18.6714 10.3152 18.7028 10.2393C18.7343 10.1635 18.7505 10.0821 18.7505 10C18.7505 9.91787 18.7343 9.83654 18.7028 9.76067C18.6714 9.68479 18.6253 9.61586 18.5672 9.55782ZM11.25 15.9914V13.75C11.25 13.5842 11.1842 13.4253 11.0669 13.3081C10.9497 13.1909 10.7908 13.125 10.625 13.125H6.25V6.875H10.625C10.7908 6.875 10.9497 6.80916 11.0669 6.69195C11.1842 6.57474 11.25 6.41576 11.25 6.25V4.0086L17.2414 10L11.25 15.9914ZM3.75 6.25V13.75C3.75 13.9158 3.68415 14.0747 3.56694 14.1919C3.44973 14.3092 3.29076 14.375 3.125 14.375C2.95924 14.375 2.80027 14.3092 2.68306 14.1919C2.56585 14.0747 2.5 13.9158 2.5 13.75V6.25C2.5 6.08424 2.56585 5.92527 2.68306 5.80806C2.80027 5.69085 2.95924 5.625 3.125 5.625C3.29076 5.625 3.44973 5.69085 3.56694 5.80806C3.68415 5.92527 3.75 6.08424 3.75 6.25Z"
          fill="#2F80ED"
        />
      </svg>
    </>
  );
}

export default PushIcon;
